
export const initAnalytics = (user, account) => {
  const pendo = window.pendo;
  if (pendo) {
    return pendo.initialize({
      visitor: {
        id: user.id,
        email: user.email,
        full_name: user.first_name + ' ' + user.last_name
      },
      account: {
        id: account.id,
        name: account.name
      }
    });
  }
};

export const trackEvent = (name, data) => {
  const pendo = window.pendo;
  if (pendo) {
    return pendo.track(name, data);
  }
};

export const clearSession = () => {
  const pendo = window.pendo;
  if (pendo) {
    return pendo.clearSession();
  }
};
